export type RuntimeEnv = {
  VITE_API_BASE_URL: string;
  VITE_BASE_URL: string;
  VITE_GOOGLE_RECAPTCHA_SITE_KEY: string;
  VITE_GOOGLE_ANALYTIC_KEY: string;
  VITE_CLARITY_KEY: string;
  VITE_GTM_ID: string;
  VITE_INTERCOM_ID: string;
  VITE_MUI_LICENSE_KEY: string;
  VITE_CLERK_PUBLISHABLE_KEY: string;
  VITE_SANITY_PROJECT_ID: string;
  VITE_SANITY_DATASET: string;
  VITE_SANITY_API_VERSION: string;
  VITE_INDEX_NOW_KEY: string;
  VITE_ENVIRONMENT: string;
};

declare global {
  interface Window {
    _env_?: RuntimeEnv;
  }
}

export const getRuntimeEnv = (): RuntimeEnv | null => {
  // Server-side: read from process.env
  if (typeof window === "undefined") {
    return {
      VITE_API_BASE_URL:
        process.env.VITE_API_BASE_URL ||
        import.meta.env.VITE_API_BASE_URL ||
        "",
      VITE_BASE_URL:
        process.env.VITE_BASE_URL || import.meta.env.VITE_BASE_URL || "",
      VITE_GOOGLE_RECAPTCHA_SITE_KEY:
        process.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY ||
        import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY ||
        "",
      VITE_GOOGLE_ANALYTIC_KEY:
        process.env.VITE_GOOGLE_ANALYTIC_KEY ||
        import.meta.env.VITE_GOOGLE_ANALYTIC_KEY ||
        "",
      VITE_CLARITY_KEY:
        process.env.VITE_CLARITY_KEY || import.meta.env.VITE_CLARITY_KEY || "",
      VITE_GTM_ID:
        process.env.VITE_GTM_ID || import.meta.env.VITE_GTM_ID || "",
      VITE_INTERCOM_ID:
        process.env.VITE_INTERCOM_ID || import.meta.env.VITE_INTERCOM_ID || "",
      VITE_MUI_LICENSE_KEY:
        process.env.VITE_MUI_LICENSE_KEY ||
        import.meta.env.VITE_MUI_LICENSE_KEY ||
        "",
      VITE_CLERK_PUBLISHABLE_KEY:
        process.env.VITE_CLERK_PUBLISHABLE_KEY ||
        import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ||
        "",
      VITE_SANITY_PROJECT_ID:
        process.env.VITE_SANITY_PROJECT_ID ||
        import.meta.env.VITE_SANITY_PROJECT_ID ||
        "",
      VITE_SANITY_DATASET:
        process.env.VITE_SANITY_DATASET ||
        import.meta.env.VITE_SANITY_DATASET ||
        "",
      VITE_SANITY_API_VERSION:
        process.env.VITE_SANITY_API_VERSION ||
        import.meta.env.VITE_SANITY_API_VERSION ||
        "",
      VITE_INDEX_NOW_KEY:
        process.env.VITE_INDEX_NOW_KEY ||
        import.meta.env.VITE_INDEX_NOW_KEY ||
        "",
      VITE_ENVIRONMENT:
        process.env.VITE_ENVIRONMENT || import.meta.env.VITE_ENVIRONMENT || "",
    };
  }

  // Client-side: read from window (hydration)
  return window._env_ ?? null;
};
